const getRootVariable = (variable) => (
  getComputedStyle(document?.documentElement)?.getPropertyValue(variable) || ''
);

const indicatorStyle = {
  padding: 5,
  '> svg': {
    width: 18,
    heigh: 18,
    color: getRootVariable('--neutral-900'),
    strokeWidth: 2,
    transition: '.3s ease-in-out',
    transitionProperty: 'color',
  },
  ':hover': {
    '> svg': {
      color: getRootVariable('--primary-500'),
    },
  },
};

const getOptionBgColorFromState = (state) => {
  if (state.isSelected) return getRootVariable('--primary-500');
  if (state.isFocused) return getRootVariable('--primary-100');
  return '';
};

const getControlBorderColor = ({ hasError, isFocused, isDisabled }) => {
  if (isDisabled) return getRootVariable('--neutral-50');
  if (hasError) return getRootVariable('--alert-500');
  if (isFocused) return getRootVariable('--primary-500');
  return getRootVariable('--neutral-200');
};

const getCustomStyles = ({ hasError }) => ({
  // CONTROL
  control: (base, { isFocused, isDisabled }) => ({
    ...base,
    minHeight: 56,
    padding: `${getRootVariable('--spacing-xs')} ${getRootVariable('--spacing-s')}`,
    backgroundColor: isDisabled ? getRootVariable('--neutral-50') : 'none',
    borderColor: getControlBorderColor({ hasError, isFocused, isDisabled }),
    boxShadow: 'none',
    transition: '.3s ease-in-out',
    transitionProperty: 'border-color',
    ':hover': {
      borderColor: getControlBorderColor({ hasError, isFocused, isDisabled }),
    },
  }),

  // INPUT
  input: (base) => ({ ...base, margin: 0, padding: 0 }),

  // PLACEHOLDER
  placeholder: (base) => ({
    ...base,
    color: getRootVariable('--neutral-500'),
  }),

  // VALUE
  valueContainer: (base) => ({ ...base, padding: 0 }),
  singleValue: (base) => ({
    ...base,
    margin: 0,
    color: getRootVariable('--neutral-900'),
  }),

  // MULTI VALUE
  multiValue: (base) => ({
    ...base,
    backgroundColor: getRootVariable('--primary-100'),
    color: getRootVariable('--primary-500'),
    borderRadius: getRootVariable('--radius-xs'),
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: getRootVariable('--primary-500'),
  }),
  multiValueRemove: (base) => ({
    ...base,
    transition: '.3s ease-in-out',
    transitionProperty: 'background-color',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: getRootVariable('--primary-200'),
      color: getRootVariable('--primary-500'),
    },
  }),

  // OPTIONS
  option: (base, state) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '10px',
    backgroundColor: getOptionBgColorFromState(state),
    ':hover': {
      backgroundColor: state.isSelected ? getRootVariable('--primary-500') : getRootVariable('--primary-100'),
    },
    transition: '.3s ease-in-out',
    transitionProperty: 'background-color',
    cursor: 'pointer',
  }),

  // INDICATORS
  indicatorsContainer: (base) => ({
    ...base,
    cursor: 'pointer',
    paddingLeft: 5,
  }),
  dropdownIndicator: (base) => ({
    ...base,
    ...indicatorStyle,
  }),
  clearIndicator: (base) => ({
    ...base,
    ...indicatorStyle,
  }),
  indicatorSeparator: () => ({ display: 'none' }),

  // MENU
  menu: (base) => ({
    ...base,
    boxShadow: getRootVariable('--shadow-m'),
    borderRadius: getRootVariable('--radius-s'),
    overflow: 'hidden',
  }),
  menuList: (base) => ({
    ...base,
    padding: 0,
    '> div': {
      padding: `${getRootVariable('--spacing-xs')} ${getRootVariable('--spacing-s')}`,
    },
  }),
});

export default getCustomStyles;
